import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import { Button } from '@thd-olt-component-react/button';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import CarPickerContext from '../../../context/CarPickerContext';
import { carPickerAnalyticsEvent } from '../../../analytics';
import styles from './car-picker-redirect.module.scss';

const classes = classNames.bind(styles);

export const CarPickerRedirect = () => {
  const { channel } = useContext(ExperienceContext);
  const {
    fitmentItems,
    pageType,
    onCarPickerUrlRedirect,
    redirectUrl,
    pipRedirectUrlLabel
  } = useContext(CarPickerContext);
  const isPip = pageType === 'pip';
  const itemFits = fitmentItems[0]?.doesFit;
  const showOnPlp = !isPip && onCarPickerUrlRedirect;
  const showOnPip = isPip && itemFits === 'no' && redirectUrl !== '';
  const shopButtonLabel = showOnPip ? `See more ${pipRedirectUrlLabel}` : 'Shop Our Universal Parts';
  const isMobile = channel === 'mobile';

  let textClasses = classes('no-vehicle-text', {
    'no-vehicle-text--mobile': isMobile
  });

  let linkClasses = classes('shop-parts-link', {
    'shop-parts-link__pip': showOnPip,
    'shop-parts-link--mobile': isMobile
  });

  let alternateProductsTextClasses = classes('pip-alternate-products-text', {
    'pip-alternate-products-text--mobile': isMobile
  });

  const handleButtonClick = () => {
    carPickerAnalyticsEvent('shop-universal-parts');
    if (onCarPickerUrlRedirect) {
      onCarPickerUrlRedirect({ redirectUrl });
    }
  };

  const handleNoVehicleClick = () => {
    carPickerAnalyticsEvent('dont-see-vehicle');
  };

  return (
    <>
      {showOnPlp && (
        <span
          role="button"
          tabIndex={0}
          className={textClasses}
          onClick={() => handleNoVehicleClick()}
        >
          Don&apos;t see your vehicle?
        </span>
      )}
      {showOnPip && (
        <div className={alternateProductsTextClasses}>
          We do have some {pipRedirectUrlLabel} in stock that will fit your vehicle.
        </div>
      )}
      {(showOnPip || showOnPlp) && (
        <div className={linkClasses}>
          <Button aria-label="shop-universal-parts" cta onClick={() => handleButtonClick()}>
            {shopButtonLabel}
          </Button>
        </div>
      )}
    </>
  );
};

CarPickerRedirect.propTypes = {};

CarPickerRedirect.defaultProps = {};

CarPickerRedirect.displayName = 'CarPickerRedirect';
